import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function CloseCircleIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4246 4.57538C23.5251 8.67588 23.5251 15.3241 19.4246 19.4246C15.3241 23.5251 8.67588 23.5251 4.57538 19.4246C0.474874 15.3241 0.474874 8.67588 4.57538 4.57538C8.67588 0.474874 15.3241 0.474874 19.4246 4.57538ZM18.0104 5.98959C21.3299 9.30905 21.3299 14.6909 18.0104 18.0104C14.691 21.3299 9.30905 21.3299 5.98959 18.0104C2.67014 14.691 2.67014 9.30905 5.98959 5.98959C9.30905 2.67014 14.691 2.67014 18.0104 5.98959Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M12 13.4142L9.58579 15.8284L8.17157 14.4142L10.5858 12L8.17157 9.58579L9.58579 8.17157L12 10.5858L14.4142 8.17157L15.8284 9.58579L13.4142 12L15.8284 14.4142L14.4142 15.8284L12 13.4142Z",
    fill: "currentColor"
  }));
}